import General from "../../profile/General";
import Health from "../../profile/Health";
import Insurance from "../../profile/Insurance";
import Passport from "../../profile/Passport";
import Church from "../../profile/Church";
import Contacts from "../../profile/Contacts";
import References from "../../profile/References";
import Skills from "../../profile/Skills";
import Education from "../../profile/Education";
import UserAdminProfileSave from "./UserAdminProfileSave";
import { useEffect, useState } from "react";
import axios from "../../../api/axios";
import { useParams } from "react-router-dom";

const endpoint = '/api/users/alluserinfo';

const SECTION_TITLES = {
  General:    'GENERAL',
  Health:     'HEALTH',
  Insurance:  'INSURANCE',
  Passport:   'PASSPORT',
  Church:     'CHURCH',
  Skills:     'SKILLS',
  Education:  'EDUCATION',
  References: 'REFERENCES',
  Contacts:   'EMERGENCY CONTACTS',
};

function SectionHeader({ title }) {
  return (
    <div className="full-row gray px-4 py-3 mb-3 mt-4 rounded" style={{ width: "calc(100% - 16px)", marginLeft: "4px", marginRight: "4px" }}>
      <h6 className="mb-0 text-uppercase fw-bold">{title}</h6>
    </div>
  );
}

const UserAdminProfile = () => {
  const { userid } = useParams();
  const [usr, setUsr] = useState(null);
  const [usrSettings, setUsrSettings] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!userid) return;

    let cancelled = false;

    const fetchUser = async () => {
      try {
        setIsLoading(true);
        const res = await axios.get(`${endpoint}/${userid}`);
        if (cancelled) return;
        setUsr(res.data.user);
        setUsrSettings(res.data.userSettings);
        setError(null);
      } catch (err) {
        if (cancelled) return;
        console.error('Error fetching user profile:', err);
        setError(err?.response?.data?.error || 'Failed to load user profile');
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    fetchUser();

    return () => {
      cancelled = true;
    };
  }, [userid]);

  if (isLoading) {
    return <div className="profileSection"><p>Loading profile...</p></div>;
  }

  if (error) {
    return <div className="profileSection"><p style={{ color: '#d32f2f' }}>{error}</p></div>;
  }

  return (
    <div className="profileSection" style={{ overflowX: "hidden" }}>
      <div className="profileSectionItem Save">
          <UserAdminProfileSave User={usr} UserSettings={usrSettings} />
      </div>
      <div className="profileSectionItem General">
        <SectionHeader title={SECTION_TITLES.General} />
        <General UseFormContext={true} User={usr} UserSettings={usrSettings} />
      </div>
      <div className="profileSectionItem Health">
        <SectionHeader title={SECTION_TITLES.Health} />
        <Health UseFormContext={true} User={usr} UserSettings={usrSettings} />
      </div>
      <div className="profileSectionItem Insurance">
        <SectionHeader title={SECTION_TITLES.Insurance} />
        <Insurance UseFormContext={true} User={usr} UserSettings={usrSettings} />
      </div>
      <div className="profileSectionItem Passport">
        <SectionHeader title={SECTION_TITLES.Passport} />
        <Passport UseFormContext={true} User={usr} UserSettings={usrSettings} />
      </div>
      <div className="profileSectionItem Church">
        <SectionHeader title={SECTION_TITLES.Church} />
        <Church UseFormContext={true} User={usr} UserSettings={usrSettings} />
      </div>
      <div className="profileSectionItem Skills">
        <SectionHeader title={SECTION_TITLES.Skills} />
        <Skills UseFormContext={true} User={usr} UserSettings={usrSettings} />
      </div>
      <div className="profileSectionItem Education">
        <SectionHeader title={SECTION_TITLES.Education} />
        <Education UseFormContext={true} User={usr} UserSettings={usrSettings} />
      </div>
      <div className="profileSectionItem References">
        <SectionHeader title={SECTION_TITLES.References} />
        <References UseFormContext={true} User={usr} UserSettings={usrSettings} />
      </div>
      <div className="profileSectionItem Contacts">
        <SectionHeader title={SECTION_TITLES.Contacts} />
        <Contacts UseFormContext={true} User={usr} UserSettings={usrSettings} />
      </div>
    </div>
  );
};

export default UserAdminProfile;